import React from 'react'

import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
//services
import { menuService } from '../../_services/menu.service';
import { cartService } from '../../_services/cart.service';
import { formatPrice } from "../../_helpers";

import Swal from 'sweetalert2/dist/sweetalert2.js'
import { postService } from '../../_services/post.service';


class Cart extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            loading: true,
            user: {
                details: {}
            },
            menu: {},
            topbarMenu: {},
            branches: {
                items: []
            },
        };

        this.handleUpdateQuantity = this.handleUpdateQuantity.bind(this);
        this.handleIncreaseQuantity = this.handleIncreaseQuantity.bind(this);
  
    }

    handleUpdateQuantity (itemId, quantity) {
        const newQuantity = Math.max(1, parseInt(quantity) || 0);
        const newCart = {
          ...this.state.cart,
          items: this.state.cart.items.map((item) =>
            Object.assign(item, item.p === itemId && { ...item, q: newQuantity })
          ),
        };

        cartService.addItem(newCart).then((cart) => {
          this.setState({
            ...this.state,
            cart: newCart,
          });
        });
    }


    removeItem(itemKey){
		cartService.getAllCart()
		.then(nonce => {
			console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
			return cartService.removeFromCart(itemKey);
		})
        .then(() => {
            // this.setState(prevState => ({
			// 	cart: {
			// 	  ...prevState.cart,
			// 	  items: prevState.cart.items.filter(item => item.key !== itemKey)
			// 	}
			//   }));
            return cartService.getAllCart();
        })
        .then(cart => {
            this.setState({ cart });
            // Set sessionStorage flag
            sessionStorage.setItem("isCartUpdate", "true");
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Item successfully removed from your shopping cart',
                showConfirmButton: false,
                timer: 1500
            })
            console.log('Item removed from cart');
        })
		// .then(() => {
		// 	// Remove the item from the state after it has been removed from the cart
		// 	this.setState(prevState => ({
		// 		cart: {
		// 		  ...prevState.cart,
		// 		  items: prevState.cart.items.filter(item => item.key !== itemKey)
		// 		}
		// 	  }));
		// 	console.log('Item removed from cart');
        //     console.log(this.state.cart)
        //     console.log()
			
		// 	//this.setState({cart});
		// })
		.catch(error => {
			console.error('Error removing item:', error);
		});
    }

    // getSubTotal (items = []) {
    //     // return items.reduce((acc, item) => {
    //     //     const itemQuantity = parseFloat(item.q.toString().split(",").join(""));
    //     //     const itemPrice = parseFloat(item.c.toString().split(",").join(""));

    //     //     return acc + (itemPrice * itemQuantity);
    //     // }, 0);
    // }

    componentDidMount() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && Date.now() < user.expiresAt) {
            this.setState({
                user: user
            });
        } else {
            this.setState({
                user: {
                    details: {}
                }
            });
        }
    
        Promise.allSettled([
            menuService.getMenuByName('default').then(menu => this.setState({ menu })),
            menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),

            // Fetch cart data immediately when the component mounts
            //this.updateCart()
            // cartService.getAllCart().then(cart => this.setState({ cart }))
            cartService.getAllCart().then(cart => {
                this.setState({ cart });
            }),
            postService.getBranches('branch','branches').then(branchesData => this.setState({branches:branchesData.items})),
        ]).then(() => this.setState({ loading: false }))
    }
    
    // componentWillUnmount() {
    //     // Clear interval when the component is unmounted
    //     clearInterval(this.interval);
    // }
    
    // updateCart() {
    //     // Fetch cart data from the server
    //     cartService.getAllCart()
    //         .then(cart => {
    //             // Update component state with the fetched cart data
    //             this.setState({ cart });
    //         })
    //         .catch(error => {
    //             console.error('Error updating cart:', error);
    //         });
    // }

    handleIncreaseQuantity = (itemKey, currentQuantity) => {
        const newQuantity = currentQuantity; // Increase quantity by 1
    
        cartService.updateCartItemQuantity(itemKey, newQuantity)
            .then(() => {
                return cartService.getAllCart();
            })
            .then(cart => {
                this.setState({ cart });
                // Set sessionStorage flag
                sessionStorage.setItem("isCartUpdate", "true");
            })
            .catch(error => {
                console.error('Failed to update cart item quantity:', error);
            });
    };

    render() {
        const { loading, user, menu, topbarMenu, branches, cart } = this.state;

        return (
            <div>
                <PreLoader loading={loading} />
                <MainMenu user={user} menu={menu} topbarMenu={topbarMenu} />
                <div className="jumbotron page-title py-5">
                    <div className="container">
                        <h1 className="text-white">Shopping Cart</h1>
                        <p className="text-muted">Review your Cart before checkout</p>
                    </div>
                </div>
                {cart &&
                <section className="m-md-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-8">
                                <div className="table-responsive">
                                    <table className="table table-hover cart-table">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="text-center">PRODUCT(S)</th>
                                                <th className="">QTY</th>
                                                <th className="text-right">UNIT PRICE</th>
                                                <th className="text-right">TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cart && cart.items.length > 0 && cart.items.map((item, index) => {
                                                // const itemQuantity = parseFloat(item.q.toString().split(",").join(""));
                                                // const itemPrice = parseFloat(item.c.toString().split(",").join(""));
                                                const itemQuantity = item.quantity;
                                                const itemPrice = item.prices?.price
                                                return (
                                                    <tr key={index}>
                                                        <td >
                                                            <div className="media flex-column flex-md-row">
                                                                {item.images &&
                                                                    <img src={item.images[0].src} className="img-fluid rounded" alt="..." style={{ maxWidth: 120, width: "100%", height: "auto" }} />
                                                                }
                                                                <div className="media-body ml-2">
                                                                    <h5 className="pt-3 m-0"><a href={"/product/"+item.s}>{item.name}</a></h5>
                                                                    <p className="m-0 my-2"><small><strong>Model:</strong> {item.variation || 'no model specified'}</small></p>
                                                                    <small className="text-success">In Stock</small>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="input-group quantity-counter">
                                                                <input type="text" className="form-control" placeholder="1" value={itemQuantity} onChange={(e) => this.handleUpdateQuantity(item.p, e.target.value)} aria-label="" aria-describedby="" />
                                                                <div className="input-group-append" id="button-addon4">
                                                                  <button
                                                                    className="btn btn-outline-secondary"
                                                                    type="button"
                                                                    onClick={() => this.handleIncreaseQuantity(item.key, itemQuantity - 1)}
                                                                  >
                                                                    <FontAwesomeIcon icon={faMinus} />
                                                                  </button>
                                                                  <button
                                                                    className="btn btn-outline-secondary"
                                                                    type="button"
                                                                    onClick={() => this.handleIncreaseQuantity(item.key, itemQuantity + 1)}
                                                                  >
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                  </button>
                                                                </div>
                                                            </div>
                                                            <button className="btn btn-outline-danger btn-sm mt-2" onClick={() => {this.removeItem(item.key)}}><i className="far fa-times-circle"></i> Remove</button>                                        
                                                        </td>
                                                        <td className="text-right text-nowrap">{formatPrice(itemPrice, { isCartPrice: true })}</td>
                                                        <td className="text-right text-nowrap"><span className="text-primary"><strong>{formatPrice(item.totals?.line_total, { isCartPrice: true })}</strong></span></td>
                                                    </tr>
                                                )
                                            })}	

                                            {(!cart.items || cart.items.length < 1) &&
                                                <tr><td align="center" colSpan="4"><em>Cart is Empty</em></td></tr>
                                            }																
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td className="bg-light" colSpan="4">
                                                    <h4 className="text-right m-0 mt-1">
                                            Subtotal <span className="text-primary"><strong>{formatPrice(cart?.totals?.total_items, { isCartPrice: true })}</strong></span>
                                                    </h4>												
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>								
                                </div>					
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4">
                                <div className="card p-4">
                                    <h3 className="mb-4 text-center">Subtotal</h3>
                                    <h3 className="font-weight-normal text-center text-primary mb-4">
                                        {formatPrice(cart?.totals?.total_items, { isCartPrice: true })}
                                    </h3>
                                        <p className="text-center bg-light py-2">
                                            <small>Shipping cost calculated at Checkout</small>
                                        </p>
                                    {/* <form action="">
                                        <div className="form-row">
                                            <div className="col-12">
                                                <label className="">Use Coupon Code</label>
                                            </div>
                                            <div className="form-group col-8">
                                                <input type="text" className="form-control" placeholder="Enter your coupon here" />
                                            </div>
                                            <div className="form-group col-4">
                                                <button className="btn btn-outline-primary btn-block">Apply</button>
                                            </div>
                                        </div>
                                    </form> */}
                                    <button className="btn btn-primary btn-block" onClick={()=> window.location = 'checkout'}><i className="fas fa-shopping-cart"></i> CHECKOUT</button>
                                    <p className="my-3"><small>By proceeding to checkout you're agreeing to our <a href="/">Privacy Policy</a>. Your security is important to us. To learn more about how we protect your payment and personal details, please read our Privacy Policy.</small></p>													
                                </div>
                                <a href="/" className="btn btn-sm btn-outline-primary my-3"><i className="fas fa-long-arrow-alt-left"></i> Continue Shopping</a>
                            </div>
                        </div>				
                    </div>
                </section>
                }
                <MainFooter menu={menu} branches={branches} />
            </div>
        )
    }
}

export { Cart };
